<template lang="html">
  <div class="user-point-history--inner">
    <div class="user-details-toolbar">
      <div class="user-details-toolbar__items">
        <select-list
          class="toolbar-nav"
          :title="$route.params.subtype"
          v-model="selectedList"
        >
          <select-option
            value="all"
            name="all"
          >
            <span>all</span>
          </select-option>
          <select-option
            :value="type.name"
            :name="type.name"
            v-for="type in types"
            :key="type.id"
          >
            <span>{{type.name}}</span>
          </select-option>
        </select-list>

        <search
          class="search-bar-wrap"
          :filterBy="filterBy"
          :dateBy="dateBy"
          @trigger="trigger"
          @refresh="search"
          @clear="search"
        >
        </search>
      </div>
    </div>

    <check-data-list
      label="loading"
      v-if="isDataLoading || isEmpty"
      :isLoading="isDataLoading"
      :isEmpty="isEmpty"
    >
    </check-data-list>

    <tbl
      :scrollable="true"
      :dataLoading="isDataLoading"
      :class="{'data-loading': showDataLoading}"
      v-else
    >
      <tbl-inner>
        <tbl-head>
          <tbl-row>
            <tbl-td
              name="no"
              :sort="true"
              @click.native="sort('id')"
            >
              no
            </tbl-td>

            <tbl-td
              name="created-at"
              :sort="true"
              @click.native="sort('created_at')"
            >
              created at
            </tbl-td>

            <tbl-td
              name="new-point"
              :sort="true"
              @click.native="sort('amount')"
            >
              new-point
            </tbl-td>

            <tbl-td
              name="old-point"
              :sort="true"
              @click.native="sort('old_point')"
            >
              old-point
            </tbl-td>

            <tbl-td
              name="amount"
              :sort="true"
              @click.native="sort('amount')"
            >
              amount
            </tbl-td>

            <tbl-td
              name="division"
              :sort="true"
              @click.native="sort('type_id')"
            >
              type
            </tbl-td>

            <tbl-td name="memo">
              memo
            </tbl-td>

            <tbl-td
              name="result"
              :sort="true"
              @click.native="sort('status')"
            >
              status
            </tbl-td>

            <tbl-td
              name="admin-ip"
              :sort="true"
              @click.native="sort('ip')"
            >
              admin-ip
            </tbl-td>

            <tbl-td
              name="from"
              :sort="true"
              @click.native="sort('admins.login_id')"
            >
              admin
            </tbl-td>
          </tbl-row>
        </tbl-head>

        <tbl-body>
          <tbl-row
            v-for="(item, x) in pointList"
            :key="item.id"
          >
            <tbl-td name="no">
              {{ generateNumber(x, params.page, params.rows, params.sort, count || 0) }}
            </tbl-td>

            <tbl-td name="created-at">
              {{item.created_at | date}}
            </tbl-td>

            <tbl-td name="new-point">
              <span> {{item.new_point | FormatAmount('whole')}} </span>
            </tbl-td>

            <tbl-td name="old-point">
              {{item.old_point | FormatAmount('whole')}}
            </tbl-td>

            <tbl-td name="amount">
              {{item.amount | FormatAmount('whole')}}
            </tbl-td>

            <tbl-td name="division">
              {{item.type}}
            </tbl-td>

            <tbl-td name="memo">
              memo
            </tbl-td>

            <tbl-td name="result">
              {{item.status | status}}
            </tbl-td>

            <tbl-td name="admin-ip">
              <span v-if="item.ip">{{item.ip}}</span>
              <span  v-else>-</span>
            </tbl-td>

            <tbl-td name="from">
              <span v-if="item.admin">{{item.admin.login_id}}</span>
              <span  v-else>-</span>
            </tbl-td>
          </tbl-row>
        </tbl-body>
      </tbl-inner>

      <tbl-footer>
        <pagination
          :total="count"
          v-model="params.page"
          :rows="params.rows"
          @page="trigger"
        >
        </pagination>
      </tbl-footer>
    </tbl>
  </div>
</template>

<script>
import { points } from '@/socket'
import { mapState, mapActions } from 'vuex'
//= mixins
import { getListStatus } from '@/assets/js/mixins/common/GetListStatus'

//= components
import Modal from '@/components/base/Modal'
import Pagination from '@/components/base/Pagination'
import Search from '@/components/base/search/Search'
import CheckDataList from '@/components/base/CheckDataList'

import FormatAmount from '@/assets/js/filters/FormatAmount'

export default {
  name: 'user-point-history',

  components: {
    Modal,
    Search,
    Pagination,
    CheckDataList
  },

  mixins: [
    getListStatus
  ],

  filters: {
    FormatAmount,
    status (stat) {
      let status = ''
      switch (stat.toLowerCase()) {
        case 'c':
          status = 'confirmed'
          break
        case 'r':
          status = 'rejected'
          break
        case 'w':
          status = 'waiting'
          break
        case 'p':
          status = 'pending'
          break
        case 'b':
          status = 'ban'
          break
        case 'd':
          status = 'deleted'
          break
      }
      return status
    }
  },

  async created () {
    await this.getTypes()
    this.search()

    points.on('convert', (data) => {
      this.search()
    })
  },

  computed: {
    ...mapState('points', ['pointList', 'count', 'types'])
  },

  data () {
    let params = Object.assign(
      {
        rows: 10,
        page: 1,
        filter_by: '',
        q: '',
        sort_by: 'id',
        sort: 'desc',
        date_from: '',
        date_to: ''
      },
      this.$route.query
    )

    return {
      params,

      isDataLoading: true,
      isEmpty: false,
      showDataLoading: false,

      selectedList: this.$route.params.subtype,

      filterBy: [
        {
          value: 'status',
          display: 'status'
        },

        {
          value: 'amount',
          display: 'amount'
        },

        {
          value: 'admin',
          display: 'admin'
        }
      ],

      dateBy: [
        {
          value: 'created_at',
          display: 'created date'
        }
      ]
    }
  },

  watch: {
    $route ($router) {
      if (!this.showDataLoading) {
        this.showDataLoading = true
      }
      this.params = this.generate($router.query)
      this.params.rows = 10
      this.search()
    }
  },

  methods: {
    ...mapActions('points', {
      getPoints: 'get',
      getTypes: 'getTypes'
    }),
    trigger (query) {
      this.params = query || this.params
      this.$router.push({ query: this.params })
    },

    async sort (sortBy) {
      if (this.params.sort === 'asc') {
        this.params.sort = 'desc'
      } else {
        this.params.sort = 'asc'
      }

      this.params.sort_by = sortBy

      if (!this.showDataLoading) {
        this.showDataLoading = true
      }

      this.$router.push({ query: this.params })
    },

    async search (query) {
      this.params = query || this.params
      // == flags reset
      this.isEmpty = false
      if (!this.showDataLoading) {
        this.isDataLoading = true
      }

      await this.getPoints({
        uid: this.$route.params.id,
        params: this.params,
        type: this.selectedList
      })

      this.isDataLoading = false
      this.showDataLoading = false
      if (!this.pointList.length) {
        this.isEmpty = true
      }
    },
    clear () {}
  }

}
</script>
